import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  standalone: false,
})
export class SupportComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    this.initSupportScripts();
  }

  initSupportScripts(): void {
    // JavaScript logic from your <script> tag here.
    // You can modularize these functions later.
    setTimeout(() => {
      const tabs = document.querySelectorAll('.tab');
      const panes = document.querySelectorAll('.tab-pane');
      const ticketListView = document.getElementById('ticket-list-view');
      const createTicketView = document.getElementById('create-ticket-view');
      const showListBtn = document.getElementById('show-ticket-list-btn');
      const showCreateBtn = document.getElementById('show-create-ticket-btn');
      const priorityOptions = document.querySelectorAll('.priority-option');
      const priorityInput = document.getElementById('priority-selected');
      const fileDropzone = document.getElementById('file-dropzone');
      const fileInput = document.getElementById('file-input');
      const fileListDiv = document.getElementById('file-list');
      const ticketForm = document.querySelector('.ticket-form');
      const ticketTypeSelect = document.getElementById('ticket-type');

      function switchToTab(targetId: string, focusCreate = false) {
        tabs.forEach((tab) =>
          tab.classList.toggle(
            'active',
            tab.getAttribute('data-tab') === targetId,
          ),
        );
        panes.forEach((pane) =>
          pane.classList.toggle('active', pane.id === targetId),
        );
        if (targetId === 'tickets') {
          if (focusCreate) showCreateTicket();
          else showTicketList();
        }
      }

      function showTicketList() {
        if (!ticketListView || !createTicketView) return;
        ticketListView.style.display = 'block';
        createTicketView.style.display = 'none';
        showListBtn?.classList.add('active');
        showCreateBtn?.classList.remove('active');
      }

      function showCreateTicket() {
        if (!ticketListView || !createTicketView) return;
        ticketListView.style.display = 'none';
        createTicketView.style.display = 'block';
        showListBtn?.classList.remove('active');
        showCreateBtn?.classList.add('active');
      }

      function resetForm() {
        if (!ticketForm) return;
        (ticketForm as HTMLFormElement).reset();
      }

      function toggleChatbot() {
        alert('Chatbot toggled (demo)');
      }

      tabs.forEach((tab) =>
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          switchToTab(tab.getAttribute('data-tab') || '');
        }),
      );

      showListBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        showTicketList();
      });
      showCreateBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        showCreateTicket();
      });
    }, 0);
  }

  toggleChatbot(): void {
    alert('Chatbot toggled (from component)');
  }
}
